import { Box, Link, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Reklamni CTA pro divaky na verejne strance s vysledky.
 * Always-on, text natvrdo — propagace platformy HasiciOnline.cz Souteze.
 * Cilovka: divak u vysledku (casto clen jineho SDH, ktery porada vlastni soutez).
 */
export const PublicPromoCta = () => {
  return (
    <Box
      sx={{
        mt: 4,
        px: 3,
        py: 2.5,
        borderRadius: 2,
        textAlign: 'center',
        border: 1,
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.06),
      }}
    >
      <Stack spacing={1} alignItems="center">
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Líbí se vám živé výsledky? <br /> Mějte je i na vaší soutěži!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Kontaktujte nás na{' '}
          <Link href="mailto:info@lindosoft.cz" underline="hover" sx={{ fontWeight: 600 }}>
            info@lindosoft.cz
          </Link>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tyto výsledky zajišťuje systém{' '}
          <Link
            href="https://www.hasicionline.cz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ fontWeight: 700 }}
          >
            HasičiOnline.cz
          </Link>{' '}
        </Typography>
      </Stack>
    </Box>
  );
};
